export const CPD_STATUSES = {
  granted: 'granted',
  applied_for: 'applied_for',
  not_applicable: 'not_applicable'
}

export const ZOOM_INFO_STATUS = {
  open: 'open',
  closed: 'closed',
  hideInProgress: 'hideInProgress'
}

export const MODAL_DELETE_CONFIRMATION_TYPE = {
  webinar: 'webinar',
  user: 'user',
  sponsor: 'sponsor'
}

export const SKIP_QUIZ_STATUS = {
  unavaliable: 'unavaliable',
  available: 'avaliable'
}



/** WEBPACK FOOTER **
 ** ./src/constants/mixed.js
 **/